import swal from "sweetalert";

export default {
  alertSuccess(title, text) {
    swal({
      title: title,
      text: text,
      icon: "success",
      buttons: false,
    });
  },
  alertError(title, text) {
    swal({
      title: title,
      text: text,
      icon: "error",
      buttons: false,
    });
  },
  setDataProductInList(data) {
    let list = [];
    data.forEach((item) => {
      if (item.id !== 0) {
        list.push({
          key: item.id,
          value: item.id,
          text: item.nombre,
          gridId: item.configuracionGrillaId,
          mailConfiguration: item.configuracionTemplateMail,
        });
      }
    });
    return list;
  },
  setDataInList(data) {
    let list = [];
    data.forEach((item) => {
      if (item.id !== 0) {
        list.push({
          key: item.id,
          value: item.id,
          text: item.nombre,
          type: item.tipo,
        });
      }
    });

    return list;
  },
  refactorDataInList(data, id) {
    let firstData = data.find((e) => e.id === id);
    if (firstData) {
      data = data.filter((e) => e.id !== id);
      data.unshift(firstData);
    }

    return data;
  },
  setDataInSearchList(data) {
    let list = [];
    data.forEach((item) => {
      if (item.id !== 0) {
        list.push({
          key: item.id,
          value: item.id,
          label: item.nombre,
        });
      }
    });

    return list;
  },
  searchTextInList(data, id) {
    let response = "";

    let result = data.find((e) => e.value === id);
    if (result) {
      response = result.text;
    }

    return response;
  },
  setDataInListSap(data) {
    let list = [];
    data.forEach((item) => {
      if (item.code !== null) {
        list.push({
          key: item.code,
          value: item.code,
          label: item.nombre,
        });
      }
    });
    return list;
  },
  setExtendCategoryDataInList(data) {
    let list = [];
    data.forEach((item) => {
      if (item.id !== 0) {
        let text = item.nombre;
        if (item.nombreCategoriaExterna !== null) {
          text += " - " + item.nombreCategoriaExterna;
        }
        list.push({
          key: item.id,
          value: item.id,
          text: text,
          type: item.tipo,
        });
      }
    });

    return list;
  },

  setStatusDataInSearchList(data) {
    let list = [];
    data.forEach((item) => {
      list.push({
        key: item.Id,
        value: item.Id,
        label: item.Text,
      });
    });

    return list;
  },
};
